// Real partners / clients TechAimz has worked with.
// Add new entries here as relationships are established.
const partners = [
  {
    name: 'Baseline Health',
    initials: 'BH',
    relationship: 'Client',
    sector: 'Healthcare AI',
    description:
      'A healthcare start-up building an AI-powered patient analytics and reporting platform that helps clinical teams turn intake data into clear, actionable reports.',
    link: '/case-study/baseline-health',
    linkLabel: 'View case study',
  },
];

export default partners;
